// Pilot scope components shared by the homepage offer card and /pilot.
export const pilotComponents = [
  { name: 'Workflow definition', covers: 'The task, current process, internal owner, and success criteria.' },
  {
    name: 'Assistant configuration',
    covers: 'One assistant built around the agreed responsibilities and approved information.',
  },
  { name: 'Scoped connections', covers: 'Only the systems and actions identified in the written scope.' },
  { name: 'Testing', covers: 'Representative scenarios, exception handling, and human review requirements.' },
  { name: 'Controlled evaluation', covers: 'A bounded period of use and feedback from the client’s team.' },
  {
    name: 'Results and handoff',
    covers: 'Findings, operating instructions, known limitations, and the recommended next step.',
  },
];

export const pilotScopeNote =
  'Additional workflows, substantial data preparation, custom applications, and complex integrations are outside the standard pilot unless explicitly included.';

export const operatingCostNote =
  'Any required software, model usage, messaging, telephony, or hosting costs are identified before kickoff and are separate unless included in the proposal.';
